import type { IProfileService } from "App/Modules/Auth";

import type { IFormContainerResolve } from "App/Modules/Services";
import { PatchDelta } from "App/Modules/Services";

import "angular-translate";

import type { IProfile, IResponseWithLoading } from "App/Modules/Models";

import { cloneDeep, isEmpty } from "lodash";

import { extendWithLoadingAndFail } from "../../../../../Services/ObservableExtensions";

export default class ProfileUserInformationEditComponentController {
    public static $inject = ["mmProfileService"];

    public original: IProfile;

    public edited: IProfile;

    public resolve: IFormContainerResolve<IProfile, void>;

    public editResponse: IResponseWithLoading<IProfile>;

    constructor(private profileService: IProfileService) {}

    public $onInit() {
        this.original = this.resolve.formData;
        this.edited = cloneDeep(this.resolve.formData);
    }

    public cancel() {
        this.resolve.options.onCancel();
    }

    public save() {
        const delta = PatchDelta.difference(this.original, this.edited);
        if (!isEmpty(delta)) {
            extendWithLoadingAndFail(this.profileService.patch(delta)).subscribe((profile) => {
                this.editResponse = profile;
                if (!profile.isLoading && profile.data) {
                    this.resolve.options.onOk(profile.data);
                }
            });
        } else {
            this.cancel();
        }
    }
}
